


import Vue from 'vue';

export default Vue.component('section-title', {
    props: {
        title: String,
        subtitle: String,
        size: {
            type: String as () => 'normal' | 'small',
            default: 'normal'
        }
    }
});
